import { render, staticRenderFns } from "./CommentWidget.vue?vue&type=template&id=edb7c2b6"
import script from "./CommentWidget.vue?vue&type=script&lang=js"
export * from "./CommentWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports